import { debounceTime, filter, mergeMap, pluck, tap } from 'rxjs/operators'
import { Component, forwardRef, Input, OnInit } from '@angular/core'
import { AbstractValueAccessor } from '@mistergreen/shared/angular-directives/abstract-value-accessor'
import { Subject } from 'rxjs'
import { Address } from '../../../configurator/ui/models/address'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { LookupAddressGQL, LookupAddressQuery } from '../../../../../generated/graphql'
import { ApolloQueryResult } from '@apollo/client/core'
import { NG_VALUE_ACCESSOR } from '@angular/forms'
import { TenantService } from '../../../../../framework/tenant/tenant.service'

@UntilDestroy()
@Component({
    selector: 'mg-deal-address',
    templateUrl: './deal-address.component.html',
    styleUrls: ['./deal-address.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DealAddressComponent),
            multi: true,
        },
    ],
})
export class DealAddressComponent extends AbstractValueAccessor implements OnInit {
    $value = new Subject<Address>()
    previousZipcode = ''

    @Input()
    disabled = false

    constructor(private lookupAddressGQL: LookupAddressGQL, private tenantService: TenantService) {
        super()
    }

    ngOnInit() {
        if (this.tenantService.tenant$.getValue() === 'mistergreen_nl') {
            this.$value
                .pipe(
                    untilDestroyed(this),
                    filter(
                        (address: Address) => address.zipcode.length >= 6 && address.zipcode !== this.previousZipcode
                    ),
                    debounceTime(200),
                    tap(address => {
                        this.previousZipcode = address.zipcode
                    }),
                    mergeMap((address: Address) =>
                        this.lookupAddressGQL.fetch({
                            input: {
                                zipcode: address.zipcode,
                                houseNumber: (address.houseNumber || '').toString(),
                                houseNumberSuffix: (address.houseNumberSuffix || '').toString(),
                            },
                        })
                    ),
                    pluck<ApolloQueryResult<LookupAddressQuery>, LookupAddressQuery['LookupAddress']>(
                        'data',
                        'LookupAddress'
                    )
                )
                .subscribe((lookupAddress: LookupAddressQuery['LookupAddress']) => {
                    this.value.city = lookupAddress.city
                    this.value.street = lookupAddress.street
                })
        }
    }

    onValueChange() {
        this.$value.next(this.value)
    }
}
